import React from 'react';
import { Card, Button, Pagination, Badge } from 'react-bootstrap';
import { FaFileExcel } from 'react-icons/fa';
import Loading from '~/Components/Loading';
import Tabela from '~/Components/TabelaDinamica/Tabela';

const fmtNum = (v) =>
  v != null
    ? Number(v).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : '-';

const numero = (v) => (
  <span style={{ fontVariantNumeric: 'tabular-nums' }}>{fmtNum(v)}</span>
);

const COLUNAS_BASE = [
  { key: 'ge', title: 'GE', align: 'center' },
  { key: 'codigo_ativo', title: 'Código', align: 'center' },
  { key: 'nome', title: 'Nome', align: 'left' },
  { key: 'nome_da_familia', title: 'Família', align: 'left' },
  { key: 'nome_variante', title: 'Variante', align: 'left' },
  { key: 'nome_qualidade', title: 'Qualidade', align: 'left' },
  { key: 'custo_medio', title: 'Custo Médio', align: 'right', render: numero },
  { key: 'saldo', title: 'Saldo', align: 'right', render: numero },
  { key: 'tipos_ativo', title: 'Tipo', align: 'center' },
  { key: 'unidade', title: 'Un.', align: 'center' },
  { key: 'manual', title: 'Manual', align: 'center' },
  {
    key: 'valor_moeda_forte',
    title: 'Moeda Forte',
    align: 'right',
    render: numero,
  },
];

const COLUNA_IMOBILIZADO = {
  key: 'codigo_imobilizado',
  title: 'Imobilizado',
  align: 'center',
};

const renderizarPaginacao = (page, totalPaginas, onMudarPagina) => {
  if (totalPaginas <= 1) return null;

  const items = [];
  const delta = 2;
  const inicio = Math.max(2, page - delta);
  const fim = Math.min(totalPaginas - 1, page + delta);

  items.push(
    <Pagination.First key="first" onClick={() => onMudarPagina(1)} disabled={page === 1} />,
    <Pagination.Prev key="prev" onClick={() => onMudarPagina(page - 1)} disabled={page === 1} />,
    <Pagination.Item key={1} active={page === 1} onClick={() => onMudarPagina(1)}>
      1
    </Pagination.Item>
  );

  if (inicio > 2) items.push(<Pagination.Ellipsis key="e1" disabled />);

  for (let i = inicio; i <= fim; i++) {
    items.push(
      <Pagination.Item key={i} active={page === i} onClick={() => onMudarPagina(i)}>
        {i}
      </Pagination.Item>
    );
  }

  if (fim < totalPaginas - 1) items.push(<Pagination.Ellipsis key="e2" disabled />);

  if (totalPaginas > 1) {
    items.push(
      <Pagination.Item
        key={totalPaginas}
        active={page === totalPaginas}
        onClick={() => onMudarPagina(totalPaginas)}
      >
        {totalPaginas}
      </Pagination.Item>
    );
  }

  items.push(
    <Pagination.Next
      key="next"
      onClick={() => onMudarPagina(page + 1)}
      disabled={page === totalPaginas}
    />,
    <Pagination.Last
      key="last"
      onClick={() => onMudarPagina(totalPaginas)}
      disabled={page === totalPaginas}
    />
  );

  return <Pagination className="mb-0">{items}</Pagination>;
};

const CardResultado = ({
  resultado,
  loading,
  loadingExport,
  formik,
  onMudarPagina,
  onExportar,
}) => {
  if (loading) return <Loading label="Gerando relatório..." />;

  if (!resultado) return null;

  const { itens, total, page, page_size, cabecalho_escopo } = resultado;
  const exibirImobilizado = formik.values.exibirImobilizado;
  const totalPaginas = Math.ceil(total / (page_size || 50));

  const colunas = exibirImobilizado
    ? [...COLUNAS_BASE, COLUNA_IMOBILIZADO]
    : COLUNAS_BASE;

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Header className="bg-white d-flex justify-content-between align-items-center flex-wrap">
        <div className="d-flex align-items-center">
          <strong className="mr-2">{cabecalho_escopo}</strong>
          <Badge variant="secondary" pill>
            {total} {total === 1 ? 'registro' : 'registros'}
          </Badge>
        </div>
        <Button
          variant="success"
          size="sm"
          onClick={onExportar}
          disabled={loadingExport || total === 0}
        >
          <FaFileExcel className="mr-1" />
          {loadingExport ? 'Exportando...' : 'Exportar Excel'}
        </Button>
      </Card.Header>

      <Card.Body className="p-2">
        <Tabela
          colunas={colunas}
          dados={itens || []}
          fontSize="13px"
          striped
          hover
        />

        {itens && itens.length > 0 && (
          <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
            <small className="text-muted">
              Mostrando {(page - 1) * (page_size || 50) + 1} até{' '}
              {Math.min(page * (page_size || 50), total)} de {total} registros
            </small>
            {renderizarPaginacao(page, totalPaginas, onMudarPagina)}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default CardResultado;
